var exports = {
  "az": "Box__t7EVBN",
  "Gy": "CircleOcticon__L6jqgO",
  "kX": "success__5DJYu6",
};

module.exports = exports;
